/**
 * Случайным образом перемешивает элементы массива
 * с использованием алгоритма Фишера—Йетса.
 *
 * Функция возвращает новый массив и НЕ мутирует исходный.
 * Алгоритм обеспечивает равномерное распределение —
 * каждая возможная перестановка имеет одинаковую вероятность.
 *
 * @param {Array} arr Исходный массив, элементы которого необходимо перемешать.
 *
 * @returns {Array} Новый массив с теми же элементами в случайном порядке.
 *
 * @example
 * const items = [1, 2, 3, 4, 5];
 * const shuffledArray = arrayShuffle(items);
 *
 * console.log(items);    // [1, 2, 3, 4, 5]
 * console.log(shuffled); // например: [3, 1, 5, 2, 4]
 */
export const arrayShuffle = arr => {
  const result = [...arr];

  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));

    [result[i], result[j]] = [result[j], result[i]];
  }

  return result;
};
